import React, { useState } from "react";

const OTP = ({
  submitOTP,
  setOtp,
  otp,
  setNewPassword,
  newPassword,
  confirmNewpassword,
  setConfirmNewPassword,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    submitOTP(otp);
  };

  return (
    <div>
      <h1>We’ll like to verify the email address you provided</h1>
      <h3 className="m-t-10">Please check the email address for an OTP</h3>
      <form className="m-t-20" onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <input
            className="styledInput m-r-10"
            type="text"
            placeholder="Enter New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            className="styledInput m-r-10"
            type="text"
            placeholder="Confirm New Password"
            value={confirmNewpassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
          <input
            className="styledInput m-r-10"
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button className="btn" type="submit">
            Submit
          </button>
        </div>
      </form>
      <p className="m-t-10">
        Didn't receive OTP? <a href="#">Resend</a>.
      </p>
    </div>
  );
};

export default OTP;
